/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import React from 'react';
import { WpIcon } from 'Wpds/components/icon';

const defaultEntryComponent = props => {
  const { mention, theme, isFocused, searchValue, ...parentProps } = props;

  return (
    <div {...parentProps}>
      <span className={`${theme.mentionSuggestionsEntryText} mt-1 mb-0`}>
        {mention.isEveryone && (
          <span className="mr-2">
            <WpIcon name="users" />
          </span>
        )}
        {mention.isEveryone ? (
          <>
            {mention.mentionEntryName}
            {' - '}
            <span className="text-muted">Mention everyone in this workspace</span>
          </>
        ) : (
          mention.mentionEntryName
        )}
      </span>
    </div>
  );
};

export default defaultEntryComponent;
